export const GET_USER_LOGIN_REQUESTED = 'GET_USER_LOGIN_REQUESTED';
export const GET_USER_LOGIN_SUCCEEDED = 'GET_USER_LOGIN_SUCCEEDED';
export const GET_USER_LOGIN_FAILED = 'GET_USER_LOGIN_FAILED';

export const INIT_APP = "INIT_APP";

export const GET_ME_REQUESTED = "GET_ME_REQUESTED";
export const GET_ME_SUCCEEDED = "GET_ME_SUCCEEDED";
export const GET_ME_FAILED = "GET_ME_FAILED";

export const GET_USER_REFRESH_REQUESTED = "GET_USER_REFRESH_REQUESTED";
export const GET_USER_REFRESH_SUCCEEDED = "GET_USER_REFRESH_SUCCEEDED";
export const GET_USER_REFRESH_FAILED = "GET_USER_REFRESH_FAILED";

export const GET_USER_PASSWORD_LINK_REQUESTED = 'GET_USER_PASSWORD_LINK_REQUESTED';
export const GET_USER_PASSWORD_LINK_SUCCEEDED = 'GET_USER_PASSWORD_LINK_SUCCEEDED';
export const GET_USER_PASSWORD_LINK_FAILED = 'GET_USER_PASSWORD_LINK_FAILED';

export const VERIFY_RESET_CODE_REQUESTED = 'VERIFY_RESET_CODE_REQUESTED';
export const VERIFY_RESET_CODE_SUCCEEDED = 'VERIFY_RESET_CODE_SUCCEEDED';
export const VERIFY_RESET_CODE_FAILED = 'VERIFY_RESET_CODE_FAILED';

export const RESET_PASSWORD_REQUESTED = 'RESET_PASSWORD_REQUESTED';
export const RESET_PASSWORD_SUCCEEDED = 'RESET_PASSWORD_SUCCEEDED';
export const RESET_PASSWORD_FAILED = 'RESET_PASSWORD_FAILED';

export const GET_CHANGE_PASSWORD_REQUESTED = 'GET_CHANGE_PASSWORD_REQUESTED';
export const GET_CHANGE_PASSWORD_SUCCEEDED = 'GET_CHANGE_PASSWORD_SUCCEEDED';
export const GET_CHANGE_PASSWORD_FAILED = 'GET_CHANGE_PASSWORD_FAILED';

export const GET_USER_LOGOUT_REQUESTED = 'GET_USER_LOGOUT_REQUESTED';
export const GET_USER_LOGOUT_SUCCEEDED = 'GET_USER_LOGOUT_SUCCEEDED';
export const GET_USER_LOGOUT_FAILED = 'GET_USER_LOGOUT_FAILED';

export const USER_LOGGED_OUT = 'USER_LOGGED_OUT';
export const USER_LOGGED_OUT_SUCCEEDED = 'USER_LOGGED_OUT_SUCCEEDED';

export const INIT_MOE_DASHBOARD="INIT_MOE_DASHBOARD";
export const INIT_STUDENT_DASHBOARD="INIT_STUDENT_DASHBOARD";
export const INIT_TEACHER_DASHBOARD="INIT_TEACHER_DASHBOARD";
export const INIT_PRINCIPAL_DASHBOARD="INIT_PRINCIPAL_DASHBOARD";
export const INIT_PISA_DISTRICT_ADMIN_REPORT = "INIT_PISA_DISTRICT_ADMIN_REPORT";
export const INIT_PISA_COUNTRY_ADMIN_REPORT = "INIT_PISA_COUNTRY_ADMIN_REPORT";

export const FETCH_MINISTRY_DASHBOARD_OVERVIEW_DATA_REQUESTED = "FETCH_MINISTRY_DASHBOARD_OVERVIEW_DATA_REQUESTED";
//create similarly more constants for the data of other rounds

export const FETCH_MINISTRY_DASHBOARD_OVERVIEW_DATA_SUCCEEDED = "FETCH_MINISTRY_DASHBOARD_OVERVIEW_DATA_SUCCEEDED";
export const FETCH_MINISTRY_DASHBOARD_OVERVIEW_DATA_FAILED = "FETCH_MINISTRY_DASHBOARD_OVERVIEW_DATA_FAILED";

export const FETCH_TEACHER_ENGAGEMENT_COUNT_REQUESTED = "FETCH_TEACHER_ENGAGEMENT_COUNT_REQUESTED";
export const FETCH_TEACHER_ENGAGEMENT_COUNT_SUCCEEDED = "FETCH_TEACHER_ENGAGEMENT_COUNT_SUCCEEDED";
export const FETCH_TEACHER_ENGAGEMENT_COUNT_FAILED = "FETCH_TEACHER_ENGAGEMENT_COUNT_FAILED";

export const FETCH_TEACHER_ENGAGEMENT_DATA_REQUESTED = "FETCH_TEACHER_ENGAGEMENT_DATA_REQUESTED";
export const FETCH_TEACHER_ENGAGEMENT_DATA_SUCCEEDED = "FETCH_TEACHER_ENGAGEMENT_DATA_SUCCEEDED";
export const FETCH_TEACHER_ENGAGEMENT_DATA_FAILED = "FETCH_TEACHER_ENGAGEMENT_DATA_FAILED";

export const FETCH_STUDENT_ENGAGEMENT_COUNT_REQUESTED = "FETCH_STUDENT_ENGAGEMENT_COUNT_REQUESTED";
export const FETCH_STUDENT_ENGAGEMENT_COUNT_SUCCEEDED = "FETCH_STUDENT_ENGAGEMENT_COUNT_SUCCEEDED";
export const FETCH_STUDENT_ENGAGEMENT_COUNT_FAILED = "FETCH_STUDENT_ENGAGEMENT_COUNT_FAILED";

export const FETCH_STUDENT_ENGAGEMENT_DATA_REQUESTED = "FETCH_STUDENT_ENGAGEMENT_DATA_REQUESTED";
export const FETCH_STUDENT_ENGAGEMENT_DATA_SUCCEEDED = "FETCH_STUDENT_ENGAGEMENT_DATA_SUCCEEDED";
export const FETCH_STUDENT_ENGAGEMENT_DATA_FAILED = "FETCH_STUDENT_ENGAGEMENT_DATA_FAILED";

export const FETCH_STUDENT_PROFICIENT_LVL_2_COUNT_REQUESTED = "FETCH_STUDENT_PROFICIENT_LVL_2_COUNT_REQUESTED";
export const FETCH_STUDENT_PROFICIENT_LVL_2_COUNT_SUCCEEDED = "FETCH_STUDENT_PROFICIENT_LVL_2_COUNT_SUCCEEDED";
export const FETCH_STUDENT_PROFICIENT_LVL_2_COUNT_FAILED = "FETCH_STUDENT_PROFICIENT_LVL_2_COUNT_FAILED";

export const FETCH_STUDENT_PROFICIENT_LVL_2_COUNT_REQUESTED2 = "FETCH_STUDENT_PROFICIENT_LVL_2_COUNT_REQUESTED2";

export const FETCH_STUDENT_PROFICIENT_LVL_2_DATA_REQUESTED = "FETCH_STUDENT_PROFICIENT_LVL_2_DATA_REQUESTED";
export const FETCH_STUDENT_PROFICIENT_LVL_2_DATA_SUCCEEDED = "FETCH_STUDENT_PROFICIENT_LVL_2_DATA_SUCCEEDED";
export const FETCH_STUDENT_PROFICIENT_LVL_2_DATA_FAILED = "FETCH_STUDENT_PROFICIENT_LVL_2_DATA_FAILED";

export const FETCH_STUDENT_PROFICIENT_LVL_2_DATA_REQUESTED2 = "FETCH_STUDENT_PROFICIENT_LVL_2_DATA_REQUESTED2";

export const FETCH_MINISTRY_QUESTIONS_ATTEMPT_COUNT_REQUESTED = "FETCH_MINISTRY_QUESTIONS_ATTEMPT_COUNT_REQUESTED";
export const FETCH_MINISTRY_QUESTIONS_ATTEMPT_COUNT_REQUESTED2 = "FETCH_MINISTRY_QUESTIONS_ATTEMPT_COUNT_REQUESTED2";

export const FETCH_MINISTRY_QUESTIONS_ATTEMPT_COUNT_SUCCEEDED = "FETCH_MINISTRY_QUESTIONS_ATTEMPT_COUNT_SUCCEEDED";
export const FETCH_MINISTRY_QUESTIONS_ATTEMPT_COUNT_FAILED = "FETCH_MINISTRY_QUESTIONS_ATTEMPT_COUNT_FAILED";

export const FETCH_MINISTRY_QUESTIONS_ATTEMPT_DATA_REQUESTED = "FETCH_MINISTRY_QUESTIONS_ATTEMPT_DATA_REQUESTED";
export const FETCH_MINISTRY_QUESTIONS_ATTEMPT_DATA_REQUESTED2 = "FETCH_MINISTRY_QUESTIONS_ATTEMPT_DATA_REQUESTED2";

export const FETCH_MINISTRY_QUESTIONS_ATTEMPT_DATA_SUCCEEDED = "FETCH_MINISTRY_QUESTIONS_ATTEMPT_DATA_SUCCEEDED";
export const FETCH_MINISTRY_QUESTIONS_ATTEMPT_DATA_FAILED = "FETCH_MINISTRY_QUESTIONS_ATTEMPT_DATA_FAILED";

export const FETCH_MINISTRY_STUDENT_IMPROVEMENT_COUNT_REQUESTED = "FETCH_MINISTRY_STUDENT_IMPROVEMENT_COUNT_REQUESTED";
export const FETCH_MINISTRY_STUDENT_IMPROVEMENT_COUNT_REQUESTED2 = "FETCH_MINISTRY_STUDENT_IMPROVEMENT_COUNT_REQUESTED2";

export const FETCH_MINISTRY_STUDENT_IMPROVEMENT_COUNT_SUCCEEDED = "FETCH_MINISTRY_STUDENT_IMPROVEMENT_COUNT_SUCCEEDED";
export const FETCH_MINISTRY_STUDENT_IMPROVEMENT_COUNT_FAILED = "FETCH_MINISTRY_STUDENT_IMPROVEMENT_COUNT_FAILED";

export const FETCH_MINISTRY_STUDENT_IMPROVEMENT_DATA_REQUESTED = "FETCH_MINISTRY_STUDENT_IMPROVEMENT_DATA_REQUESTED";
export const FETCH_MINISTRY_STUDENT_IMPROVEMENT_DATA_REQUESTED2 = "FETCH_MINISTRY_STUDENT_IMPROVEMENT_DATA_REQUESTED2";

export const FETCH_MINISTRY_STUDENT_IMPROVEMENT_DATA_SUCCEEDED = "FETCH_MINISTRY_STUDENT_IMPROVEMENT_DATA_SUCCEEDED";
export const FETCH_MINISTRY_STUDENT_IMPROVEMENT_DATA_FAILED = "FETCH_MINISTRY_STUDENT_IMPROVEMENT_DATA_FAILED";

export const FETCH_TEACHER_ENGAGEMENT_PERCENTAGE_TABLE_REQUESTED = "FETCH_TEACHER_ENGAGEMENT_PERCENTAGE_TABLE_REQUESTED";
export const FETCH_TEACHER_ENGAGEMENT_PERCENTAGE_TABLE_SUCCEEDED = "FETCH_TEACHER_ENGAGEMENT_PERCENTAGE_TABLE_SUCCEEDED";
export const FETCH_TEACHER_ENGAGEMENT_PERCENTAGE_TABLE_FAILED = "FETCH_TEACHER_ENGAGEMENT_PERCENTAGE_TABLE_FAILED";

export const FETCH_TEACHER_ENGAGEMENT_HOURS_TABLE_REQUESTED = "FETCH_TEACHER_ENGAGEMENT_HOURS_TABLE_REQUESTED";
export const FETCH_TEACHER_ENGAGEMENT_HOURS_TABLE_SUCCEEDED = "FETCH_TEACHER_ENGAGEMENT_HOURS_TABLE_SUCCEEDED";
export const FETCH_TEACHER_ENGAGEMENT_HOURS_TABLE_FAILED = "FETCH_TEACHER_ENGAGEMENT_HOURS_TABLE_FAILED";

export const FETCH_STUDENT_ENGAGEMENT_PERCENTAGE_TABLE_REQUESTED = "FETCH_STUDENT_ENGAGEMENT_PERCENTAGE_TABLE_REQUESTED";
export const FETCH_STUDENT_ENGAGEMENT_PERCENTAGE_TABLE_SUCCEEDED = "FETCH_STUDENT_ENGAGEMENT_PERCENTAGE_TABLE_SUCCEEDED";
export const FETCH_STUDENT_ENGAGEMENT_PERCENTAGE_TABLE_FAILED = "FETCH_STUDENT_ENGAGEMENT_PERCENTAGE_TABLE_FAILED";

export const FETCH_STUDENT_ENGAGEMENT_HOURS_TABLE_REQUESTED = "FETCH_STUDENT_ENGAGEMENT_HOURS_TABLE_REQUESTED";
export const FETCH_STUDENT_ENGAGEMENT_HOURS_TABLE_SUCCEEDED = "FETCH_STUDENT_ENGAGEMENT_HOURS_TABLE_SUCCEEDED";
export const FETCH_STUDENT_ENGAGEMENT_HOURS_TABLE_FAILED = "FETCH_STUDENT_ENGAGEMENT_HOURS_TABLE_FAILED";

export const FETCH_STUDENT_PROFICIENT_LVL_2_PERCENT_TABLE_REQUESTED = "FETCH_STUDENT_PROFICIENT_LVL_2_PERCENT_TABLE_REQUESTED";
export const FETCH_STUDENT_PROFICIENT_LVL_2_PERCENT_TABLE_SUCCEEDED = "FETCH_STUDENT_PROFICIENT_LVL_2_PERCENT_TABLE_SUCCEEDED";
export const FETCH_STUDENT_PROFICIENT_LVL_2_PERCENT_TABLE_FAILED = "FETCH_STUDENT_PROFICIENT_LVL_2_PERCENT_TABLE_FAILED";

export const FETCH_STUDENT_PROFICIENT_LVL_2_NUMBER_TABLE_REQUESTED = "FETCH_STUDENT_PROFICIENT_LVL_2_NUMBER_TABLE_REQUESTED";
export const FETCH_STUDENT_PROFICIENT_LVL_2_NUMBER_TABLE_SUCCEEDED = "FETCH_STUDENT_PROFICIENT_LVL_2_NUMBER_TABLE_SUCCEEDED";
export const FETCH_STUDENT_PROFICIENT_LVL_2_NUMBER_TABLE_FAILED = "FETCH_STUDENT_PROFICIENT_LVL_2_NUMBER_TABLE_FAILED";

export const FETCH_MINISTRY_STUDENT_IMPROVEMENT_PERCENTAGE_TABLE_REQUESTED = "FETCH_MINISTRY_STUDENT_IMPROVEMENT_PERCENTAGE_TABLE_REQUESTED";
export const FETCH_MINISTRY_STUDENT_IMPROVEMENT_PERCENTAGE_TABLE_SUCCEEDED = "FETCH_MINISTRY_STUDENT_IMPROVEMENT_PERCENTAGE_TABLE_SUCCEEDED";
export const FETCH_MINISTRY_STUDENT_IMPROVEMENT_PERCENTAGE_TABLE_FAILED = "FETCH_MINISTRY_STUDENT_IMPROVEMENT_PERCENTAGE_TABLE_FAILED";

export const FETCH_MINISTRY_STUDENT_IMPROVEMENT_NUMBER_TABLE_REQUESTED = "FETCH_MINISTRY_STUDENT_IMPROVEMENT_NUMBER_TABLE_REQUESTED";
export const FETCH_MINISTRY_STUDENT_IMPROVEMENT_NUMBER_TABLE_SUCCEEDED = "FETCH_MINISTRY_STUDENT_IMPROVEMENT_NUMBER_TABLE_SUCCEEDED";
export const FETCH_MINISTRY_STUDENT_IMPROVEMENT_NUMBER_TABLE_FAILED = "FETCH_MINISTRY_STUDENT_IMPROVEMENT_NUMBER_TABLE_FAILED";

export const FETCH_MINISTRY_QUESTIONS_ATTEMPTED_TABLE_REQUESTED = "FETCH_MINISTRY_QUESTIONS_ATTEMPTED_TABLE_REQUESTED";
export const FETCH_MINISTRY_QUESTIONS_ATTEMPTED_TABLE_SUCCEEDED = "FETCH_MINISTRY_QUESTIONS_ATTEMPTED_TABLE_SUCCEEDED";
export const FETCH_MINISTRY_QUESTIONS_ATTEMPTED_TABLE_FAILED = "FETCH_MINISTRY_QUESTIONS_ATTEMPTED_TABLE_FAILED";

export const FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_REQUESTED = "FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_REQUESTED";
export const FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_SUCCEEDED = "FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_SUCCEEDED";
export const FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_FAILED = "FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_FAILED";

export const FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_ROUND_TWO_REQUESTED = "FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_ROUND_TWO_REQUESTED";
export const FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_ROUND_TWO_SUCCEEDED = "FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_ROUND_TWO_SUCCEEDED";
export const FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_ROUND_TWO_FAILED = "FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_ROUND_TWO_FAILED";

export const FETCH_STUDENT_TIME_CHART_DATA_REQUESTED = "FETCH_STUDENT_TIME_CHART_DATA_REQUESTED";
export const FETCH_STUDENT_TIME_CHART_DATA_SUCCEEDED = "FETCH_STUDENT_TIME_CHART_DATA_SUCCEEDED";
export const FETCH_STUDENT_TIME_CHART_DATA_FAILED = "FETCH_STUDENT_TIME_CHART_DATA_FAILED";

export const FETCH_STUDENT_QUESTION_COMPLETION_CHART_DATA_REQUESTED = "FETCH_STUDENT_QUESTION_COMPLETION_CHART_DATA_REQUESTED";
export const FETCH_STUDENT_QUESTION_COMPLETION_CHART_DATA_SUCCEEDED = "FETCH_STUDENT_QUESTION_COMPLETION_CHART_DATA_SUCCEEDED";
export const FETCH_STUDENT_QUESTION_COMPLETION_CHART_DATA_FAILED = "FETCH_STUDENT_QUESTION_COMPLETION_CHART_DATA_FAILED";

export const FETCH_STUDENT_QUESTION_COMPLETION_CHART_DATA_REQUESTED2 = "FETCH_STUDENT_QUESTION_COMPLETION_CHART_DATA_REQUESTED2";
export const FETCH_STUDENT_QUESTION_COMPLETION_CHART_DATA_SUCCEEDED2 = "FETCH_STUDENT_QUESTION_COMPLETION_CHART_DATA_SUCCEEDED2";
export const FETCH_STUDENT_QUESTION_COMPLETION_CHART_DATA_FAILED2 = "FETCH_STUDENT_QUESTION_COMPLETION_CHART_DATA_FAILED2";

export const FETCH_STUDENT_IMPROVEMENT_CHART_DATA_REQUESTED = "FETCH_STUDENT_IMPROVEMENT_CHART_DATA_REQUESTED";
export const FETCH_STUDENT_IMPROVEMENT_CHART_DATA_SUCCEEDED = "FETCH_STUDENT_IMPROVEMENT_CHART_DATA_SUCCEEDED";
export const FETCH_STUDENT_IMPROVEMENT_CHART_DATA_FAILED = "FETCH_STUDENT_IMPROVEMENT_CHART_DATA_FAILED";

export const FETCH_STUDENT_IMPROVEMENT_CHART_DATA_REQUESTED2 = "FETCH_STUDENT_IMPROVEMENT_CHART_DATA_REQUESTED2";
export const FETCH_STUDENT_IMPROVEMENT_CHART_DATA_SUCCEEDED2 = "FETCH_STUDENT_IMPROVEMENT_CHART_DATA_SUCCEEDED2";
export const FETCH_STUDENT_IMPROVEMENT_CHART_DATA_FAILED2 = "FETCH_STUDENT_IMPROVEMENT_CHART_DATA_FAILED2";

export const FETCH_STUDENT_TIME_DATA_REQUESTED = "FETCH_STUDENT_TIME_DATA_REQUESTED";
export const FETCH_STUDENT_TIME_DATA_SUCCEEDED = "FETCH_STUDENT_TIME_DATA_SUCCEEDED";
export const FETCH_STUDENT_TIME_DATA_FAILED = "FETCH_STUDENT_TIME_DATA_FAILED";

export const FETCH_STUDENT_QUESTION_COMPLETION_DATA_REQUESTED = "FETCH_STUDENT_QUESTION_COMPLETION_DATA_REQUESTED";
export const FETCH_STUDENT_QUESTION_COMPLETION_DATA_SUCCEEDED = "FETCH_STUDENT_QUESTION_COMPLETION_DATA_SUCCEEDED";
export const FETCH_STUDENT_QUESTION_COMPLETION_DATA_FAILED = "FETCH_STUDENT_QUESTION_COMPLETION_DATA_FAILED";

export const FETCH_STUDENT_IMPROVEMENT_DATA_REQUESTED = "FETCH_STUDENT_IMPROVEMENT_DATA_REQUESTED";
export const FETCH_STUDENT_IMPROVEMENT_DATA_SUCCEEDED = "FETCH_STUDENT_IMPROVEMENT_DATA_SUCCEEDED";
export const FETCH_STUDENT_IMPROVEMENT_DATA_FAILED = "FETCH_STUDENT_IMPROVEMENT_DATA_FAILED";

export const FETCH_STUDENT_DETAILED_IMPROVEMENT_DATA_REQUESTED = "FETCH_STUDENT_DETAILED_IMPROVEMENT_DATA_REQUESTED";
export const FETCH_STUDENT_DETAILED_IMPROVEMENT_DATA_SUCCEEDED = "FETCH_STUDENT_DETAILED_IMPROVEMENT_DATA_SUCCEEDED";
export const FETCH_STUDENT_DETAILED_IMPROVEMENT_DATA_FAILED = "FETCH_STUDENT_DETAILED_IMPROVEMENT_DATA_FAILED";

export const FETCH_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_REQUESTED = "FETCH_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_REQUESTED";
export const FETCH_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_SUCCEEDED = "FETCH_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_SUCCEEDED";
export const FETCH_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_FAILED = "FETCH_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_FAILED";

export const FETCH_STUDENT_TRIES_QUESTIONS_DATA_REQUESTED ="FETCH_STUDENT_TRIES_QUESTIONS_DATA_REQUESTED";
export const FETCH_STUDENT_TRIES_QUESTIONS_DATA_SUCCEEDED ="FETCH_STUDENT_TRIES_QUESTIONS_DATA_SUCCEEDED";
export const FETCH_STUDENT_TRIES_QUESTIONS_DATA_FAILED ="FETCH_STUDENT_TRIES_QUESTIONS_DATA_FAILED";

export const FETCH_STUDENT_PRACTICE_REPORT_QUESTION_REQUESTED="FETCH_STUDENT_PRACTICE_REPORT_QUESTION_REQUESTED";
export const FETCH_STUDENT_PRACTICE_REPORT_QUESTION_SUCCEEDED="FETCH_STUDENT_PRACTICE_REPORT_QUESTION_SUCCEEDED";
export const FETCH_STUDENT_PRACTICE_REPORT_QUESTION_FAILED="FETCH_STUDENT_PRACTICE_REPORT_QUESTION_FAILED";

export const FETCH_STUDENT_IMPROVEMENT_REPORT_QUESTION_REQUESTED="FETCH_STUDENT_IMPROVEMENT_REPORT_QUESTION_REQUESTED";
export const FETCH_STUDENT_IMPROVEMENT_REPORT_QUESTION_SUCCEEDED="FETCH_STUDENT_IMPROVEMENT_REPORT_QUESTION_SUCCEEDED";
export const FETCH_STUDENT_IMPROVEMENT_REPORT_QUESTION_FAILED="FETCH_STUDENT_IMPROVEMENT_REPORT_QUESTION_FAILED";

export const SET_CURRENT_QUESTION_VIEW_EXERCISE = "SET_CURRENT_QUESTION_VIEW_EXERCISE";
export const SET_CURRENT_QUESTION_VIEW_STUDENT = "SET_CURRENT_QUESTION_VIEW_STUDENT";
export const SET_CURRENT_QUESTION_VIEW_STUDENT_CLASS = "SET_CURRENT_QUESTION_VIEW_STUDENT_CLASS";

export const RESET_CURRENT_QUESTION_VIEW_STUDENT = "RESET_CURRENT_QUESTION_VIEW_STUDENT";
export const RESET_CURRENT_QUESTION_VIEW_STUDENT_CLASS = "RESET_CURRENT_QUESTION_VIEW_STUDENT_CLASS";
export const EXIT_DASHBOARD_QUESTION_VIEW = "EXIT_DASHBOARD_QUESTION_VIEW";

export const FETCH_TEACHER_DASHBOARD_OVERVIEW_DATA_REQUESTED = "FETCH_TEACHER_DASHBOARD_OVERVIEW_DATA_REQUESTED";
export const FETCH_TEACHER_DASHBOARD_OVERVIEW_DATA_SUCCEEDED = "FETCH_TEACHER_DASHBOARD_OVERVIEW_DATA_SUCCEEDED";
export const FETCH_TEACHER_DASHBOARD_OVERVIEW_DATA_FAILED = "FETCH_TEACHER_DASHBOARD_OVERVIEW_DATA_FAILED";

export const FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_REQUESTED="FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_REQUESTED";
export const FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_SUCCEEDED="FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_SUCCEEDED";
export const FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_FAILED="FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_FAILED";

export const FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_REQUESTED="FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_REQUESTED";
export const FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_SUCCEEDED="FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_SUCCEEDED";
export const FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_FAILED="FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_FAILED";

export const FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_REQUESTED="FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_REQUESTED";
export const FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_SUCCEEDED="FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_SUCCEEDED";
export const FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_FAILED="FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_FAILED";

export const FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_REQUESTED="FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_REQUESTED";
export const FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_SUCCEEDED="FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_SUCCEEDED";
export const FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_FAILED="FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_FAILED";

export const FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_REQUESTED="FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_REQUESTED";
export const FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_SUCCEEDED="FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_SUCCEEDED";
export const FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_FAILED="FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_FAILED";

export const FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_REQUESTED="FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_REQUESTED";
export const FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_SUCCEEDED="FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_SUCCEEDED";
export const FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_FAILED="FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_FAILED";

export const FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_REQUESTED="FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_REQUESTED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_SUCCEEDED="FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_SUCCEEDED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_FAILED="FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_FAILED";

export const FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_CHART_REQUESTED="FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_CHART_REQUESTED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_CHART_SUCCEEDED="FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_CHART_SUCCEEDED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_CHART_FAILED="FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_CHART_FAILED";

export const FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_REQUESTED="FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_REQUESTED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_SUCCEEDED="FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_SUCCEEDED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_FAILED="FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_FAILED";

export const FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_REQUESTED="FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_REQUESTED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_SUCCEEDED="FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_SUCCEEDED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_FAILED="FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_FAILED";

export const FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_REQUESTED="FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_REQUESTED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_SUCCEEDED="FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_SUCCEEDED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_FAILED="FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_FAILED";

export const FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_REQUESTED="FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_REQUESTED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_SUCCEEDED="FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_SUCCEEDED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_FAILED="FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_FAILED";

export const FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_REQUESTED="FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_REQUESTED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_REQUESTED2="FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_REQUESTED2"; //for round 2
export const FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_SUCCEEDED="FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_SUCCEEDED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_FAILED="FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_FAILED";

export const FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_CHART_REQUESTED="FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_CHART_REQUESTED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_CHART_REQUESTED2="FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_CHART_REQUESTED2"; //for round 2
export const FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_CHART_SUCCEEDED="FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_CHART_SUCCEEDED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_CHART_FAILED="FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_CHART_FAILED";

export const FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_REQUESTED="FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_REQUESTED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_REQUESTED2="FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_REQUESTED2"; //for round 2
export const FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_SUCCEEDED="FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_SUCCEEDED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_FAILED="FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_FAILED";

export const FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_CHART_REQUESTED="FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_CHART_REQUESTED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_CHART_REQUESTED2="FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_CHART_REQUESTED2"; //for round 2
export const FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_CHART_SUCCEEDED="FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_CHART_SUCCEEDED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_CHART_FAILED="FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_CHART_FAILED";

export const FETCH_TEACHER_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_REQUESTED="FETCH_TEACHER_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_REQUESTED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_SUCCEEDED="FETCH_TEACHER_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_SUCCEEDED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_FAILED="FETCH_TEACHER_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_FAILED";

export const FETCH_TEACHER_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_REQUESTED="FETCH_TEACHER_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_REQUESTED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_SUCCEEDED="FETCH_TEACHER_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_SUCCEEDED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_FAILED="FETCH_TEACHER_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_FAILED";

export const FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_REQUESTED="FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_REQUESTED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_SUCCEEDED="FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_SUCCEEDED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_FAILED="FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_FAILED";

export const FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_REQUESTED="FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_REQUESTED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_SUCCEEDED="FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_SUCCEEDED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_FAILED="FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_FAILED";

export const FETCH_TEACHER_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_REQUESTED="FETCH_TEACHER_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_REQUESTED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_SUCCEEDED="FETCH_TEACHER_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_SUCCEEDED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_FAILED="FETCH_TEACHER_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_FAILED";

export const FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TOPICS_REQUESTED = "FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TOPICS_REQUESTED";
export const FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TOPICS_SUCCEEDED = "FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TOPICS_SUCCEEDED";
export const FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TOPICS_FAILED = "FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TOPICS_FAILED";

export const FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_CHART_REQUESTED="FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_CHART_REQUESTED";
export const FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_CHART_REQUESTED2="FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_CHART_REQUESTED2"; //for round 2
export const FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_CHART_SUCCEEDED="FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_CHART_SUCCEEDED";
export const FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_CHART_FAILED="FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_CHART_FAILED";

export const FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TABLE_REQUESTED="FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TABLE_REQUESTED";
export const FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TABLE_SUCCEEDED="FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TABLE_SUCCEEDED";
export const FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TABLE_FAILED="FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TABLE_FAILED";
export const EXIT_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TABLE = "EXIT_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TABLE";

export const FETCH_TEACHER_DASHBOARD_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_REQUESTED = "FETCH_TEACHER_DASHBOARD_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_REQUESTED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_SUCCEEDED = "FETCH_TEACHER_DASHBOARD_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_SUCCEEDED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_FAILED = "FETCH_TEACHER_DASHBOARD_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_FAILED";

export const FETCH_TEACHER_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_REQUESTED="FETCH_TEACHER_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_REQUESTED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_SUCCEEDED="FETCH_TEACHER_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_SUCCEEDED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_FAILED="FETCH_TEACHER_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_FAILED";

export const FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_REQUESTED="FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_REQUESTED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_SUCCEEDED="FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_SUCCEEDED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_FAILED="FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_FAILED";

export const FETCH_TEACHER_DASHBOARD_STUDENT_TRIES_QUESTIONS_DATA_REQUESTED ="FETCH_TEACHER_DASHBOARD_STUDENT_TRIES_QUESTIONS_DATA_REQUESTED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_TRIES_QUESTIONS_DATA_SUCCEEDED ="FETCH_TEACHER_DASHBOARD_STUDENT_TRIES_QUESTIONS_DATA_SUCCEEDED";
export const FETCH_TEACHER_DASHBOARD_STUDENT_TRIES_QUESTIONS_DATA_FAILED ="FETCH_TEACHER_DASHBOARD_STUDENT_TRIES_QUESTIONS_DATA_FAILED";

export const FETCH_STUDENT_LIST_DROPDOWN_REQUESTED = "FETCH_STUDENT_LIST_DROPDOWN_REQUESTED";
export const FETCH_STUDENT_LIST_DROPDOWN_SUCCEEDED = "FETCH_STUDENT_LIST_DROPDOWN_SUCCEEDED";
export const FETCH_STUDENT_LIST_DROPDOWN_FAILED= "FETCH_STUDENT_LIST_DROPDOWN_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_OVERVIEW_DATA_REQUESTED = "FETCH_PRINCIPAL_DASHBOARD_OVERVIEW_DATA_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_OVERVIEW_DATA_SUCCEEDED = "FETCH_PRINCIPAL_DASHBOARD_OVERVIEW_DATA_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_OVERVIEW_DATA_FAILED = "FETCH_PRINCIPAL_DASHBOARD_OVERVIEW_DATA_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_COUNT_REQUESTED="FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_COUNT_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_COUNT_SUCCEEDED="FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_COUNT_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_COUNT_FAILED="FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_COUNT_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_CHART_REQUESTED="FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_CHART_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_CHART_SUCCEEDED="FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_CHART_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_CHART_FAILED="FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_CHART_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_REQUESTED="FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_SUCCEEDED="FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_FAILED="FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_REQUESTED="FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_SUCCEEDED="FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_FAILED="FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_REQUESTED="FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_SUCCEEDED="FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_FAILED="FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_REQUESTED="FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_SUCCEEDED="FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_FAILED="FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_REQUESTED="FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_SUCCEEDED="FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_FAILED="FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_REQUESTED="FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_SUCCEEDED="FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_FAILED="FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_COUNT_REQUESTED="FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_COUNT_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_COUNT_SUCCEEDED="FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_COUNT_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_COUNT_FAILED="FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_COUNT_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_CHART_REQUESTED="FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_CHART_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_CHART_SUCCEEDED="FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_CHART_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_CHART_FAILED="FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_CHART_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_REQUESTED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_SUCCEEDED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_FAILED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_CHART_REQUESTED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_CHART_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_CHART_SUCCEEDED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_CHART_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_CHART_FAILED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_CHART_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_REQUESTED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_SUCCEEDED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_FAILED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_REQUESTED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_SUCCEEDED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_FAILED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_REQUESTED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_SUCCEEDED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_FAILED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_REQUESTED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_SUCCEEDED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_FAILED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_REQUESTED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_REQUESTED2="FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_REQUESTED2"; //round 2
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_SUCCEEDED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_FAILED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_CHART_REQUESTED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_CHART_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_CHART_REQUESTED2="FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_CHART_REQUESTED2"; //round 2
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_CHART_SUCCEEDED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_CHART_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_CHART_FAILED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_CHART_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_REQUESTED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_REQUESTED2="FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_REQUESTED2"; //round 2
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_SUCCEEDED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_FAILED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_CHART_REQUESTED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_CHART_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_CHART_REQUESTED2="FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_CHART_REQUESTED2"; //round 2
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_CHART_SUCCEEDED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_CHART_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_CHART_FAILED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_CHART_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_TEACHER_USAGE_HOURS_TABLE_REQUESTED="FETCH_PRINCIPAL_DASHBOARD_TEACHER_USAGE_HOURS_TABLE_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_TEACHER_USAGE_HOURS_TABLE_SUCCEEDED="FETCH_PRINCIPAL_DASHBOARD_TEACHER_USAGE_HOURS_TABLE_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_TEACHER_USAGE_HOURS_TABLE_FAILED="FETCH_PRINCIPAL_DASHBOARD_TEACHER_USAGE_HOURS_TABLE_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_REQUESTED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_SUCCEEDED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_FAILED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_REQUESTED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_SUCCEEDED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_FAILED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_REQUESTED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_SUCCEEDED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_FAILED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_REQUESTED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_SUCCEEDED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_FAILED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_REQUESTED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_SUCCEEDED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_FAILED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TOPICS_REQUESTED = "FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TOPICS_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TOPICS_REQUESTED2 = "FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TOPICS_REQUESTED2"; //round 2
export const FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TOPICS_SUCCEEDED = "FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TOPICS_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TOPICS_FAILED = "FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TOPICS_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_CHART_REQUESTED="FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_CHART_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_CHART_REQUESTED2="FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_CHART_REQUESTED2"; //round 2
export const FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_CHART_SUCCEEDED="FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_CHART_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_CHART_FAILED="FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_CHART_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TABLE_REQUESTED="FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TABLE_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TABLE_SUCCEEDED="FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TABLE_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TABLE_FAILED="FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TABLE_FAILED";
export const EXIT_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TABLE = "EXIT_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TABLE";

export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_REQUESTED = "FETCH_PRINCIPAL_DASHBOARD_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_SUCCEEDED = "FETCH_PRINCIPAL_DASHBOARD_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_FAILED = "FETCH_PRINCIPAL_DASHBOARD_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_TRIES_QUESTIONS_DATA_REQUESTED ="FETCH_PRINCIPAL_DASHBOARD_STUDENT_TRIES_QUESTIONS_DATA_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_TRIES_QUESTIONS_DATA_SUCCEEDED ="FETCH_PRINCIPAL_DASHBOARD_STUDENT_TRIES_QUESTIONS_DATA_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_TRIES_QUESTIONS_DATA_FAILED ="FETCH_PRINCIPAL_DASHBOARD_STUDENT_TRIES_QUESTIONS_DATA_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_REQUESTED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_SUCCEEDED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_FAILED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_REQUESTED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_SUCCEEDED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_FAILED="FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_FAILED";

export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_LIST_DROPDOWN_REQUESTED = "FETCH_PRINCIPAL_DASHBOARD_STUDENT_LIST_DROPDOWN_REQUESTED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_LIST_DROPDOWN_SUCCEEDED = "FETCH_PRINCIPAL_DASHBOARD_STUDENT_LIST_DROPDOWN_SUCCEEDED";
export const FETCH_PRINCIPAL_DASHBOARD_STUDENT_LIST_DROPDOWN_FAILED= "FETCH_PRINCIPAL_DASHBOARD_STUDENT_LIST_DROPDOWN_FAILED";

export const FETCH_DISTRICT_SCHOOLS_REQUESTED = "FETCH_DISTRICT_SCHOOLS_REQUESTED";
export const FETCH_DISTRICT_SCHOOLS_SUCCEEDED = "FETCH_DISTRICT_SCHOOLS_SUCCEEDED";
export const FETCH_DISTRICT_SCHOOLS_FAILED = "FETCH_DISTRICT_SCHOOLS_FAILED";

export const FETCH_DISTRICTS_REQUESTED = "FETCH_DISTRICTS_REQUESTED";
export const FETCH_DISTRICTS_SUCCEEDED = "FETCH_DISTRICTS_SUCCEEDED";
export const FETCH_DISTRICTS_FAILED = "FETCH_DISTRICTS_FAILED";

export const DOWNLOAD_DISTRICT_DATA_REQUESTED = "DOWNLOAD_DISTRICT_DATA_REQUESTED";
export const DOWNLOAD_DISTRICT_DATA_SUCCEEDED = "DOWNLOAD_DISTRICT_DATA_SUCCEEDED";
export const DOWNLOAD_DISTRICT_DATA_FAILED = "DOWNLOAD_DISTRICT_DATA_FAILED";

export const DOWNLOAD_ALL_MOE_REPORTS_REQUESTED = "DOWNLOAD_ALL_MOE_REPORTS_REQUESTED";
export const DOWNLOAD_ALL_MOE_REPORTS_SUCCEEDED = "DOWNLOAD_ALL_MOE_REPORTS_SUCCEEDED";
export const DOWNLOAD_ALL_MOE_REPORTS_FAILED = "DOWNLOAD_ALL_MOE_REPORTS_FAILED";

export const DOWNLOAD_PAGINATION_DATA_REQUESTED = "DOWNLOAD_PAGINATION_DATA_REQUESTED";
export const DOWNLOAD_PAGINATION_DATA_SUCCEEDED = "DOWNLOAD_PAGINATION_DATA_SUCCEEDED";
export const DOWNLOAD_PAGINATION_DATA_FAILED = "DOWNLOAD_PAGINATION_DATA_FAILED";

export const RESET_DOWNLOAD_PAGINATION_DATA = "RESET_DOWNLOAD_PAGINATION_DATA";

export const ROUND_TWO = "ROUND_TWO";

export const loginUser = (user,history) => {
  return {
    type: GET_USER_LOGIN_REQUESTED,
    user,
    history
  };
};

export const initApp = (history) => {
  return {
    type: INIT_APP,
    history
  };
};

export const getMe = (history) => {
  return {
    type: GET_ME_REQUESTED,
    history
  };
};

export const refreshUser = (history) => {
  return {
    type: GET_USER_REFRESH_REQUESTED,
    history
  };
};

export const forgotPassword = (user) => {
  return {
    type: GET_USER_PASSWORD_LINK_REQUESTED,
    user,
  };
};

export const resetPasswordSucceeded = (payload) => {
  return {
    type: RESET_PASSWORD_SUCCEEDED,
    ...payload,
  };
};

export const verifyResetCode = (queryParams,language) => {
  return {
    type: VERIFY_RESET_CODE_REQUESTED,
    queryParams,
    language
  };
};

export const resetPassword = (userInfo,history) => {
  return {
    type: RESET_PASSWORD_REQUESTED,
    userInfo,
    history
  };
};

export const submitChangePassword = (newPassword, oldPassword) => {
  return {
    type: GET_CHANGE_PASSWORD_REQUESTED,
    newPassword,
    oldPassword,
  }
}

export const logoutUser = (history) => {
  return {
    type: GET_USER_LOGOUT_REQUESTED,
    history
  };
};

export const userLoggedOut = (history) => {
  return {
    type: USER_LOGGED_OUT,
    history
  };
};

export const getUserPasswordLinkSucceeded = (payload) => {
  return {
    type: GET_USER_PASSWORD_LINK_SUCCEEDED,
    ...payload,
  };
};

export const getUserLoginSucceeded = (payload) => {
  return {
    type: GET_USER_LOGIN_SUCCEEDED,
    ...payload,
  };
};

export const initMOEDashboard=()=>{
  return {
    type: INIT_MOE_DASHBOARD,
  };
}

export const fetchMinistryDashboardOverviewData = (subject) => {
  return {
    type: FETCH_MINISTRY_DASHBOARD_OVERVIEW_DATA_REQUESTED,
    subject,
  };
};

export const fetchTeacherEngagementCount = (subject, district) => {
  return {
    type: FETCH_TEACHER_ENGAGEMENT_COUNT_REQUESTED,
    subject,
    district,
  };
};

export const fetchTeacherEngagementData = (subject, district) => {
  return {
    type: FETCH_TEACHER_ENGAGEMENT_DATA_REQUESTED,
    subject,
    district,
  };
};

export const fetchStudentEngagementCount = (subject, district) => {
  return {
    type: FETCH_STUDENT_ENGAGEMENT_COUNT_REQUESTED,
    subject,
    district,
  };
};

export const fetchStudentEngagementData = (subject, district) => {
  return {
    type: FETCH_STUDENT_ENGAGEMENT_DATA_REQUESTED,
    subject,
    district,
  };
};

export const fetchStudentProficientLvlTwoCount = (subject, district, round) => {
  return {
    type: FETCH_STUDENT_PROFICIENT_LVL_2_COUNT_REQUESTED + (round == 2 ? "2" : ""),
    subject,
    district,
    round
  };
};

export const fetchStudentProficientLvlTwoData = (subject, district, round) => {
  return {
    type: FETCH_STUDENT_PROFICIENT_LVL_2_DATA_REQUESTED + (round == 2 ? "2" : ""),
    subject,
    district,
    round
  };
};

export const fetchMinistryTotalQuestionsAttemptCount = (subject, district, round) => {
  return {
    type: FETCH_MINISTRY_QUESTIONS_ATTEMPT_COUNT_REQUESTED + (round == 2 ? "2" : ""),
    subject,
    district,
    round
  };
};

export const fetchMinistryTotalQuestionsAttemptData = (subject, district, round) => {
  return {
    type: FETCH_MINISTRY_QUESTIONS_ATTEMPT_DATA_REQUESTED + (round == 2 ? "2" : ""),
    subject,
    district,
    round
  };
};

export const fetchMinistryStudentImprovementCount = (subject, district, round) => {
  return {
    type: FETCH_MINISTRY_STUDENT_IMPROVEMENT_COUNT_REQUESTED + (round == 2 ? "2" : ""),
    subject,
    district,
    round,
  };
};

export const fetchMinistryStudentImprovementData = (subject, district, round) => {
  return {
    type: FETCH_MINISTRY_STUDENT_IMPROVEMENT_DATA_REQUESTED + (round == 2 ? "2" : ""),
    subject,
    district,
    round,
  };
};

export const fetchTeacherEngagementPercentageTable = (
  subject,
  district,
  school,
  limit,
  offset,
  sortVal
) => {
  return {
    type: FETCH_TEACHER_ENGAGEMENT_PERCENTAGE_TABLE_REQUESTED,
    subject,
    district,
    school,
    limit,
    offset,
    sortVal,
  };
};

export const fetchTeacherEngagementHoursTable = (
  subject,
  district,
  format,
  school,
  limit,
  offset,
  sortVal
) => {
  return {
    type: FETCH_TEACHER_ENGAGEMENT_HOURS_TABLE_REQUESTED,
    subject,
    district,
    format,
    school,
    limit,
    offset,
    sortVal,
  };
};

export const fetchStudentEngagementPercentageTable = (
  subject,
  district,
  school,
  limit,
  offset,
  sortVal
) => {
  return {
    type: FETCH_STUDENT_ENGAGEMENT_PERCENTAGE_TABLE_REQUESTED,
    subject,
    district,
    school,
    limit,
    offset,
    sortVal,
  };
};

export const fetchStudentEngagementHoursTable = (
  subject,
  district,
  school,
  limit,
  offset,
  sortVal
) => {
  return {
    type: FETCH_STUDENT_ENGAGEMENT_HOURS_TABLE_REQUESTED,
    subject,
    district,
    school,
    limit,
    offset,
    sortVal,
  };
};

export const fetchStudentProficientLvlTwoPercentTable = (
  subject,
  district,
  school,
  limit,
  offset,
  sortVal,
  round
) => {
  return {
    type: FETCH_STUDENT_PROFICIENT_LVL_2_PERCENT_TABLE_REQUESTED,
    subject,
    district,
    school,
    limit,
    offset,
    sortVal,
    round
  };
};

export const fetchStudentProficientLvlTwoNumberTable = (
  subject,
  district,
  school,
  limit,
  offset,
  sortVal,
  round
) => {
  return {
    type: FETCH_STUDENT_PROFICIENT_LVL_2_NUMBER_TABLE_REQUESTED,
    subject,
    district,
    school,
    limit,
    offset,
    sortVal,
    round
  };
};

export const fetchMinistryStudentImprovementPercentageTable = (
  subject,
  district,
  school,
  limit,
  offset,
  sortVal,
  round
) => {
  return {
    type: FETCH_MINISTRY_STUDENT_IMPROVEMENT_PERCENTAGE_TABLE_REQUESTED,
    subject,
    district,
    school,
    limit,
    offset,
    sortVal,
    round
  };
};

export const fetchMinistryStudentImprovementNumberTable = (
  subject,
  district,
  school,
  limit,
  offset,
  sortVal,
  round
) => {
  return {
    type: FETCH_MINISTRY_STUDENT_IMPROVEMENT_NUMBER_TABLE_REQUESTED,
    subject,
    district,
    school,
    limit,
    offset,
    sortVal,
    round
  };
};

export const fetchMinistryQuestionsAttemptedTable = (
  subject,
  district,
  school,
  limit,
  offset,
  sortVal,
  round
) => {
  return {
    type: FETCH_MINISTRY_QUESTIONS_ATTEMPTED_TABLE_REQUESTED,
    subject,
    district,
    school,
    limit,
    offset,
    sortVal,
    round
  };
};

export const initStudentDashboard=()=>{
  return {
    type: INIT_STUDENT_DASHBOARD,
  };
}

export const fetchStudentDashboardOverviewData = (class_code) => {
  return {
    type: FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_REQUESTED,
    class_code,
  };
};

export const fetchStudentDashboardOverviewDataRoundTwo = (class_code) => {
  return {
    type: FETCH_STUDENT_DASHBOARD_OVERVIEW_DATA_ROUND_TWO_REQUESTED,
    class_code,
  };
};

export const fetchStudentTimeChartData = (class_code,filter_class) => {
  return {
    type: FETCH_STUDENT_TIME_CHART_DATA_REQUESTED,
    class_code,
    filter_class
  };
};

export const fetchStudentQuestionCompletionChartData = (class_code,filter_class, round) => {
  return {
    type: FETCH_STUDENT_QUESTION_COMPLETION_CHART_DATA_REQUESTED + (round == 2 ? "2"  : ""),
    class_code,
    filter_class,
    round
  };
};

export const fetchStudentImprovementChartData = (class_code,filter_class, round) => {
  return {
    type: FETCH_STUDENT_IMPROVEMENT_CHART_DATA_REQUESTED + (round == 2 ? "2"  : ""),
    class_code,
    filter_class,
    round
  };
};

export const fetchStudentTimeData = (class_code, format) => {
  return {
    type: FETCH_STUDENT_TIME_DATA_REQUESTED,
    class_code,
    format,
  };
};

export const fetchStudentQuestionCompletionData = (class_code, round) => {
  return {
    type: FETCH_STUDENT_QUESTION_COMPLETION_DATA_REQUESTED,
    class_code,
    round
  };
};

export const fetchStudentImprovementData = (class_code, round) => {
  return {
    type: FETCH_STUDENT_IMPROVEMENT_DATA_REQUESTED,
    class_code,
    round
  };
};

export const fetchStudentDetailedImprovementData = (class_code, student_id, round) => {
  return {
    type: FETCH_STUDENT_DETAILED_IMPROVEMENT_DATA_REQUESTED,
    class_code,
    student_id,
    round
  };
};

export const fetchStudentTopicCompletedQuestionData = (
  class_code,
  student_id,
  topic_id
) => {
  return {
    type: FETCH_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_REQUESTED,
    class_code,
    student_id,
    topic_id
  };
};

export const fetchStudentTriesQuestionData = (
  class_code,
  student_id,
  topic_id,
  try_count
) => {
  return {
    type: FETCH_STUDENT_TRIES_QUESTIONS_DATA_REQUESTED,
    class_code,
    student_id,
    topic_id,
    try_count
  };
};

export const fetchStudentPracticeReportQuestions=(class_code,attempt_ids)=>{
  return {
    type: FETCH_STUDENT_PRACTICE_REPORT_QUESTION_REQUESTED,
    class_code,
    attempt_ids,
  };
}

export const fetchStudentImprovementReportQuestions=(class_code,attempt_ids)=>{
  return {
    type: FETCH_STUDENT_IMPROVEMENT_REPORT_QUESTION_REQUESTED,
    class_code,
    attempt_ids,
  };
}

export const setCurrentQuestionViewExercise = (exercise, tryCount) => {
  return {
    type: SET_CURRENT_QUESTION_VIEW_EXERCISE,
    exercise,
    tryCount
  }
}

export const setCurrentQuestionViewStudent = (id,name) => {
  return {
    type: SET_CURRENT_QUESTION_VIEW_STUDENT,
    id,
    name
  }
}

export const setCurrentQuestionViewStudentClass = (class_name,class_code) => {
  return {
    type: SET_CURRENT_QUESTION_VIEW_STUDENT_CLASS,
    class_name,
    class_code
  }
}

export const resetCurrentQuestionViewStudent=()=>{
  return {
    type: RESET_CURRENT_QUESTION_VIEW_STUDENT
  }
}

export const resetCurrentQuestionViewStudentClass=()=>{
  return {
    type: RESET_CURRENT_QUESTION_VIEW_STUDENT_CLASS
  }
}

export const exitDashboardQuestionView = () => {
  return {
    type: EXIT_DASHBOARD_QUESTION_VIEW,
  };
};

export const initTeacherDashboard=()=>{
  return {
    type: INIT_TEACHER_DASHBOARD,
  };
}

export const fetchTeacherDashboardOverviewData = (subject) => {
  return {
    type: FETCH_TEACHER_DASHBOARD_OVERVIEW_DATA_REQUESTED,
    subject,
  };
};

export const fetchTeacherDashboardNationwideStudentEngagementCount=(subject)=>{
  return {
    type: FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_REQUESTED,
    subject,
  };
}

export const fetchTeacherDashboardNationwideStudentEngagementChart=(subject)=>{
  return {
    type: FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_REQUESTED,
    subject,
  };
}

export const fetchTeacherDashboardNationwideStudentProfLvlTwoCount=(subject)=>{
  return {
    type: FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_REQUESTED,
    subject,
  };
}

export const fetchTeacherDashboardNationwideStudentProfLvlTwoChart=(subject)=>{
  return {
    type: FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_REQUESTED,
    subject,
  };
}

export const fetchTeacherDashboardNationwideStudentProfLvlThreeCount=(subject)=>{
  return {
    type: FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_REQUESTED,
    subject,
  };
}

export const fetchTeacherDashboardNationwideStudentProfLvlThreeChart=(subject)=>{
  return {
    type: FETCH_TEACHER_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_REQUESTED,
    subject,
  };
}

export const fetchTeacherDashboardStudentEngagementCount=(subject)=>{
  return {
    type: FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_REQUESTED,
    subject,
  };
}

export const fetchTeacherDashboardStudentEngagementChart=(subject,filter_class)=>{
  return {
    type: FETCH_TEACHER_DASHBOARD_STUDENT_ENGAGEMENT_CHART_REQUESTED,
    subject,
    filter_class
  };
}


export const fetchTeacherDashboardStudentCompletedTwentyQuestionsCount=(subject)=>{
  return {
    type: FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_REQUESTED,
    subject,
    
  };
}

export const fetchTeacherDashboardStudentCompletedTwentyQuestionsChart=(subject,filter_class)=>{
  return {
    type: FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_REQUESTED,
    subject,
    filter_class
  };
}
export const fetchTeacherDashboardStudentCompletedTenQuestionsCount=(subject)=>{
  return {
    type: FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_REQUESTED,
    subject,
    
  };
}

export const fetchTeacherDashboardStudentCompletedTenQuestionsChart=(subject,filter_class)=>{
  return {
    type: FETCH_TEACHER_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_REQUESTED,
    subject,
    filter_class
  };
}

export const fetchTeacherDashboardStudentProfLvlTwoCount=(subject, round)=>{
  return {
    type: FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_REQUESTED + (round == 2 ? "2"  : ""),
    subject,
    round
  };
}

export const fetchTeacherDashboardStudentProfLvlTwoChart=(subject,filter_class,round)=>{
  return {
    type: FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_CHART_REQUESTED + (round == 2 ? "2"  : ""),
    subject,
    filter_class,
    round
  };
}

export const fetchTeacherDashboardStudentImprovementCount=(subject,round)=>{
  return {
    type: FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_REQUESTED + (round == 2 ? "2"  : ""),
    subject,
    round
  };
}

export const fetchTeacherDashboardStudentImprovementChart=(subject,filter_class,round)=>{
  return {
    type: FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_CHART_REQUESTED + (round == 2 ? "2"  : ""),
    subject,
    filter_class,
    round
  };
}

export const fetchTeacherDashboardStudentHoursTable=(subject,time_format,filter_class,student_name,limit,offset)=>{
  return {
    type: FETCH_TEACHER_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_REQUESTED,
    subject,
    time_format,
    filter_class,
    student_name,
    limit,
    offset

  };
}

export const fetchTeacherDashboardStudentQuestionsCompletedTable=(subject,filter_class,student_name,limit,offset,round)=>{
  return {
    type: FETCH_TEACHER_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_REQUESTED,
    subject,
    filter_class,
    student_name,
    limit,
    offset,
    round
  };
}

export const fetchTeacherDashboardStudentProfLvlTwoTable=(subject,filter_class,student_name,limit,offset, round)=>{
  return {
    type: FETCH_TEACHER_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_REQUESTED,
    subject,
    filter_class,
    student_name,
    limit,
    offset,
    round
  };
}

export const fetchTeacherDashboardStudentImprovementTable=(subject,filter_class,student_name,limit,offset, round)=>{
  return {
    type: FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_REQUESTED,
    subject,
    filter_class,
    student_name,
    limit,
    offset,
    round
  };
}

export const fetchTeacherDashboardStudentDetailedImprovementTable=(subject,student_id,filter_class, round)=>{
  return {
    type: FETCH_TEACHER_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_REQUESTED,
    subject,
    student_id,
    filter_class,
    round
  };
}

export const fetchTeacherDashboardQuestionAnalysisTopics = (subject, filter_class, round) => {
  return {
    type: FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TOPICS_REQUESTED,
    subject,
    filter_class,
    round
  };
}

export const fetchTeacherDashboardQuestionAnalysisChart=(subject,filter_class, round)=>{
  return {
    type: FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_CHART_REQUESTED + (round == 2 ? "2"  : ""),
    subject,
    filter_class,
    round
  };
}

export const fetchTeacherDashboardStudentTopicCompletedQuestionData=(subject,topic_id,student_id)=>{
  return {
    type: FETCH_TEACHER_DASHBOARD_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_REQUESTED,
    subject,
    topic_id,
    student_id
  };
}

export const fetchTeacherDashboardStudentTriesQuestionData=(subject,topic_id,student_id,try_count)=>{
  return {
    type: FETCH_TEACHER_DASHBOARD_STUDENT_TRIES_QUESTIONS_DATA_REQUESTED,
    subject,
    topic_id,
    student_id,
    try_count
  };
}

export const fetchTeacherDashboardStudentPracticeReportQuestions=(subject,attempt_ids)=>{
  return {
    type: FETCH_TEACHER_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_REQUESTED,
    subject,
    attempt_ids,
  };
}

export const fetchTeacherDashboardStudentImprovementReportQuestions=(subject,attempt_ids)=>{
  return {
    type: FETCH_TEACHER_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_REQUESTED,
    subject,
    attempt_ids,
  };
}

export const fetchTeacherDashboardQuestionAnalysisTable=(subject,filter_class,topic_id, round)=>{
  return {
    type: FETCH_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TABLE_REQUESTED,
    subject,
    filter_class,
    topic_id,
    round
  };
}

export const exitTeacherDashboardQuestionAnalysisTable = () => {
  return {
    type: EXIT_TEACHER_DASHBOARD_QUESTION_ANALYSIS_TABLE,
  };
}

export const fetchStudentListDropdown=(subject,filter_class, round)=>{
  return {
    type: FETCH_STUDENT_LIST_DROPDOWN_REQUESTED,
    subject,
    filter_class,
    round
  };
}

export const initPrincipalDashboard=(school_id)=>{
  return {
    type: INIT_PRINCIPAL_DASHBOARD,
    school_id
  };
}

export const fetchPrincipalDashboardOverviewData = (subject) => {
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_OVERVIEW_DATA_REQUESTED,
    subject,
  };
};

export const fetchPrincipalDashboardNationwideTeacherEngagementCount=(subject)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_COUNT_REQUESTED,
    subject
  };
}

export const fetchPrincipalDashboardNationwideTeacherEngagementChart=(subject)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_TEACHER_ENGAGEMENT_CHART_REQUESTED,
    subject
  };
}

export const fetchPrincipalDashboardNationwideStudentEngagementCount=(subject)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_COUNT_REQUESTED,
    subject,
    
  };
}

export const fetchPrincipalDashboardNationwideStudentEngagementChart=(subject)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_ENGAGEMENT_CHART_REQUESTED,
    subject,
  };
}

export const fetchPrincipalDashboardNationwideStudentProfLvlTwoCount=(subject)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_COUNT_REQUESTED,
    subject,
  };
}

export const fetchPrincipalDashboardNationwideStudentProfLvlTwoChart=(subject)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTWO_CHART_REQUESTED,
    subject,
  };
}

export const fetchPrincipalDashboardNationwideStudentProfLvlThreeCount=(subject)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_COUNT_REQUESTED,
    subject,
  };
}

export const fetchPrincipalDashboardNationwideStudentProfLvlThreeChart=(subject)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_NATIONWIDE_STUDENT_PROFLVLTHREE_CHART_REQUESTED,
    subject,
  };
}

export const fetchPrincipalDashboardTeacherEngagementCount=(subject)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_COUNT_REQUESTED,
    subject,
  };
}

export const fetchPrincipalDashboardTeacherEngagementChart=(subject,filter_class)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_TEACHER_ENGAGEMENT_CHART_REQUESTED,
    subject,
    filter_class
  };
}

export const fetchPrincipalDashboardStudentEngagementCount=(subject)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_COUNT_REQUESTED,
    subject,
  };
}

export const fetchPrincipalDashboardStudentEngagementChart=(subject,filter_class)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_ENGAGEMENT_CHART_REQUESTED,
    subject,
    filter_class
  };
}

export const fetchPrincipalDashboardStudentCompletedTwentyQuestionsCount=(subject)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_COUNT_REQUESTED,
    subject,
  };
}

export const fetchPrincipalDashboardStudentCompletedTwentyQuestionsChart=(subject,filter_class)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TWENTY_QUESTIONS_CHART_REQUESTED,
    subject,
    filter_class
  };
}

export const fetchPrincipalDashboardStudentCompletedTenQuestionsCount=(subject)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_COUNT_REQUESTED,
    subject,
  };
}

export const fetchPrincipalDashboardStudentCompletedTenQuestionsChart=(subject,filter_class)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_COMPLETED_TEN_QUESTIONS_CHART_REQUESTED,
    subject,
    filter_class
  };
}

export const fetchPrincipalDashboardStudentProfLvlTwoCount=(subject, round)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_COUNT_REQUESTED + (round == 2 ? "2"  : ""),
    subject,
    round
  };
}

export const fetchPrincipalDashboardStudentProfLvlTwoChart=(subject,filter_class,round)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_CHART_REQUESTED + (round == 2 ? "2"  : ""),
    subject,
    filter_class,
    round
  };
}

export const fetchPrincipalDashboardStudentImprovementCount=(subject, round)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_COUNT_REQUESTED + (round == 2 ? "2"  : ""),
    subject,
    round
  };
}

export const fetchPrincipalDashboardStudentImprovementChart=(subject,filter_class, round)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_CHART_REQUESTED + (round == 2 ? "2"  : ""),
    subject,
    filter_class,
    round
  };
}

export const fetchPrincipalDashboardTeacherHoursTable=(subject,time_format,filter_class,teacher_name,limit,offset)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_TEACHER_USAGE_HOURS_TABLE_REQUESTED,
    subject,
    time_format,
    filter_class,
    teacher_name,
    limit,
    offset
  };
}

export const fetchPrincipalDashboardStudentHoursTable=(subject,time_format,filter_class,student_name,limit,offset)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_USAGE_HOURS_TABLE_REQUESTED,
    subject,
    time_format,
    filter_class,
    student_name,
    limit,
    offset
  };
}

export const fetchPrincipalDashboardStudentQuestionsCompletedTable=(subject,filter_class,student_name,limit,offset, round)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_QUESTIONS_COMPLETED_TABLE_REQUESTED,
    subject,
    filter_class,
    student_name,
    limit,
    offset,
    round
  };
}

export const fetchPrincipalDashboardStudentProfLvlTwoTable=(subject,filter_class,student_name,limit,offset, round)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_PROFLVLTWO_TABLE_REQUESTED,
    subject,
    filter_class,
    student_name,
    limit,
    offset,
    round
  };
}

export const fetchPrincipalDashboardStudentImprovementTable=(subject,filter_class,student_name,limit,offset, round)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_TABLE_REQUESTED,
    subject,
    filter_class,
    student_name,
    limit,
    offset,
    round
  };
}

export const fetchPrincipalDashboardStudentDetailedImprovementTable=(subject,student_id,filter_class,round)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_DETAILED_IMPROVEMENT_TABLE_REQUESTED,
    subject,
    student_id,
    filter_class,
    round
  };
}

export const fetchPrincipalDashboardQuestionAnalysisTopics = (subject, filter_class, round) => {
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TOPICS_REQUESTED + (round == 2 ? "2"  : ""),
    subject,
    filter_class,
    round
  };
}

export const fetchPrincipalDashboardQuestionAnalysisChart=(subject,filter_class, round)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_CHART_REQUESTED + (round == 2 ? "2"  : ""),
    subject,
    filter_class,
    round
  };
}

export const fetchPrincipalDashboardQuestionAnalysisTable=(subject,filter_class,topic_id, round)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TABLE_REQUESTED,
    subject,
    filter_class,
    topic_id,
    round
  };
}

export const exitPrincipalDashboardQuestionAnalysisTable = () => {
  return {
    type: EXIT_PRINCIPAL_DASHBOARD_QUESTION_ANALYSIS_TABLE,
  };
}

export const fetchPrincipalDashboardStudentTopicCompletedQuestionData=(subject,topic_id,student_id)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_TOPIC_COMPLETED_QUESTIONS_DATA_REQUESTED,
    subject,
    topic_id,
    student_id
  };
}

export const fetchPrincipalDashboardStudentTriesQuestionData=(subject,topic_id,student_id,try_count)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_TRIES_QUESTIONS_DATA_REQUESTED,
    subject,
    topic_id,
    student_id,
    try_count
  };
}

export const fetchPrincipalDashboardStudentPracticeReportQuestions=(subject,attempt_ids)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_PRACTICE_REPORT_QUESTION_REQUESTED,
    subject,
    attempt_ids,
  };
}

export const fetchPrincipalDashboardStudentImprovementReportQuestions=(subject,attempt_ids)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_IMPROVEMENT_REPORT_QUESTION_REQUESTED,
    subject,
    attempt_ids,
  };
}

export const fetchPrincipalDashboardStudentListDropdown=(subject,filter_class)=>{
  return {
    type: FETCH_PRINCIPAL_DASHBOARD_STUDENT_LIST_DROPDOWN_REQUESTED,
    subject,
    filter_class
  };
}

export const initPISADistrictAdminReport=()=>{
  return {
    type: INIT_PISA_DISTRICT_ADMIN_REPORT,
  };
}

export const fetchDistrictSchools=(limit,offset,name,district)=>{
  return {
    type: FETCH_DISTRICT_SCHOOLS_REQUESTED,
    limit,
    offset,
    name,
    district
  };
}

export const initPISACountryAdminReport=()=>{
  return {
    type: INIT_PISA_COUNTRY_ADMIN_REPORT,
  };
}

export const fetchDistricts = (limit,offset,name) => {
  return {
    type: FETCH_DISTRICTS_REQUESTED,
    limit,
    offset,
    name
  };
}

export const downloadDistrictData = (district,country) => {
  return {
    type: DOWNLOAD_DISTRICT_DATA_REQUESTED,
    district,
    country
  }
}

export const downloadAllMoeReports = (subject, language, AllMoeReportsDownloadPayloadData) => {
  return {
    type: DOWNLOAD_ALL_MOE_REPORTS_REQUESTED,
    subject,
    language,
    AllMoeReportsDownloadPayloadData
  }
}

export const downloadPagingationData = (param,subject,language,metricName, topic, round) => {
  return {
    type: DOWNLOAD_PAGINATION_DATA_REQUESTED,
    param,
    subject,
    language,
    metricName,
    topic,
    round
  }
}

export const resetDownloadPaginationData = () => {
  return {
    type: RESET_DOWNLOAD_PAGINATION_DATA
  }
}